import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import less from 'less'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import datas from './assets/data.js'
import "./assets/main.less"
import "@/assets/Animation.css"
import '@/assets/animate.min.css'
Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.use(less)
Vue.use(VueAwesomeSwiper)
Vue.prototype.$Datas = datas


// Vue.directive("intersect", {
//   bind(el, binding, vnode) {
//     const observer = new IntersectionObserver(async (entries, observer) => {
//       if (entries[0].isIntersecting && entries[0].intersectionRatio > 0) {
//         // console.log("--监测元素出现在可视区范围--", entries);
//         if (binding.value) {
//           await binding.value();
//           observer.unobserve(el);
//         }
//       }
//     });
//     observer.observe(el);
//     vnode.elm.$observer = observer;
//   },
//   unbind(el, binding, vnode) {
//     if (vnode.elm.$observer) {
//       vnode.elm.$observer.disconnect();
//       vnode.elm.$observer = null;
//     }
//   },
// });

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
